// * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// * Copyright 2023 The Geek-AI Authors. All rights reserved.
// * Use of this source code is governed by a Apache-2.0 license
// * that can be found in the LICENSE file.
// * @Author yangjian102621@163.com
// * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

import axios from "axios";
import { getSessionId, getUserToken, removeUserToken } from "@/store/session";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
const router = useRouter();

const urlMap = {
  development: window.location.origin,
  production: window.location.origin + "/api",
};
console.log(
  "urlMap[process.env]urlMap[process.env]  ",
  process.env.VUE_APP_API_HOST
);
axios.defaults.timeout = 60000; //180000
axios.defaults.baseURL = urlMap[process.env.NODE_ENV]; //process.env.VUE_APP_API_HOST
// axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers["server"] = true;

// HTTP拦截器
axios.interceptors.request.use(
  (config) => {
    // set token
    config.headers["Chat-Token"] = getSessionId();
    config.headers["Ba-User-Token"] = getUserToken();
    // console.log("请求参数", config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (response) => {
    if (response.status === 204) {
      // 大概率是cdn直传返回结果
      return response;
    }
    const res = response.data;
    if (res.code != 1 && res.code != 20000) {
      ElMessage({
        type: "error",
        message: res.msg,
      });
      if (res.code == 303 || res.code == 409) {
        // 登录过期
        removeUserToken();
        setTimeout(() => {
          // router.replace("/");
          window.location.replace("/login");
        }, 100);
        return false;
      }
      return false;
    }
    return response;
  },
  (error) => {
    console.log("error  ", error);
    let msg = "网络错误!";
    if (error.response.status === 404) {
      msg = "请求地址不存在!";
    }
    // if (error.response.status === 401 || error.response.status === 400) {
    //   removeUserToken();
    //   return Promise.reject(error.response.data);
    // }
    ElMessage({
      type: "error",
      message: msg,
    });
    return Promise.reject(error);
  }
);

// send a http get request
export function httpGet(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// send a http post request
export function httpPost(url, data = {}, options = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// send a http delete request
export function httpDelete(url, data = {}, options = {}) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, data, options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
